import React, { useState } from "react";
import { Box, Tabs, Tab, Toolbar, Typography, Paper, Chip, Stack } from "@mui/material";

import DamagedRawMaterials from "./DamagedRawMaterials";
import DamagedProducts from "./DamagedProducts";
import { KeyboardArrowLeftOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const cardSx = {
    borderRadius: 3,
    border: "1px solid #e7e7e7",
    backgroundColor: "#fff",
    overflow: "hidden",
};

const DamagedMaterials = () => {
    const [tab, setTab] = useState(0);
    const navigate = useNavigate();

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "#f6f7fb" }}>
            <Toolbar />

            <Box sx={{ px: { xs: 2, md: 4 }, pt: 6 }}>
                {/* Header + Tabs */}
                <Paper elevation={0} sx={cardSx}>
                    <Box
                        sx={{
                            px: { xs: 1, md: 2 },
                            py: 1.5, // reduced height
                            borderBottom: "1px solid #f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                            flexWrap: "wrap",
                        }}
                    >
                        {/* Title Section */}
                        <Stack flexDirection={'row'}>
                            <KeyboardArrowLeftOutlined sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)} fontSize="large" />
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: 17,
                                        fontWeight: 800,
                                        color: "#0f172a",
                                    }}
                                >
                                    Damaged / Wastage Stock Entry
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: 12.5,
                                        color: "#64748b",
                                        mt: 0.3,
                                    }}
                                >
                                    Log damaged or wasted raw materials or products.
                                </Typography>
                            </Box>
                        </Stack>

                        <Tabs
                            value={tab}
                            onChange={(_, v) => setTab(v)}
                            sx={{
                                minHeight: 44,
                                "& .MuiTabs-indicator": { display: "none" },
                                "& .MuiTab-root": {
                                    minHeight: 44,
                                    minWidth: 200,
                                    px: 4,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 700,
                                    fontSize: 14,
                                    mx: 1,
                                    color: "#475569",
                                    border: "1px solid #e2e8f0",
                                    transition: "all 0.2s ease",
                                },
                                "& .MuiTab-root:hover": {
                                    bgcolor: "#6aa4de",
                                    color: "#fff !important",
                                    border: 'none'
                                },
                                "& .Mui-selected": {
                                    bgcolor: "#003049",
                                    color: "#fff !important",
                                    border: "1px solid #003049",
                                },
                            }}
                        >
                            <Tab label="Raw Materials" />
                            <Tab label="Products" />
                        </Tabs>


                    </Box>
                </Paper>

                <Paper elevation={0} sx={{ ...cardSx, mt: 2 }}>
                    <Box sx={{ p: { xs: 2, md: 2.5 } }}>
                        {tab === 0 ? <DamagedRawMaterials /> : <DamagedProducts />}
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};

export default DamagedMaterials;
